export enum TransportationTypeEn {
  rentalCar = 1, //Xe thuê ngoài
  shuttle = 2, // Xe nội bộ
  selfSufficient = 3 // Xe tự túc
}
